import React from 'react'
import CansCocktailsTemplate from './template_updates/CansCocktailsTemplate'

class CansCocktails extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            cansMenu: '',
            cocktailsMenu: '',
            mocktailsMenus: ''
        }
    }
    filterBrewery = (brewery) => {
        console.log(brewery)
        if (brewery.includes("Brewery")){
            return brewery.replace("Brewery", "")
        } else if (brewery.includes("Brewing") || brewery.includes('Company') || brewery.includes('Co.') || brewery.includes("Cooperative")){
            return brewery.replace('Brewing', "").replace('Company', "").replace('Co.', "").replace("Cooperative", "COOP").replace('Co ', "")
        } else if (brewery.includes('Brew Labs')){
            return brewery.replace('Brew Labs', "")
        }  else if (brewery.includes('Werks')){
            return brewery.replace("Werks", "")
        } else if (brewery.includes("Beer")){
            return (brewery.replace("Beer", ""))
        } else if (brewery.includes("Anheuser-Busch")){
            return "AB InBev"
        } 
            else {
            return brewery
        }
    }
    refactorAbv = (abv) => {
        let number = parseFloat(abv)
        return number
    }
    filterStyle = (style) => {
        
        if (style === "IPA - American"){
            return "IPA"
        } else if (style === "Stout - Milk / Sweet"){
            return "Stout"
        } else if (style === "Sour - Fruited Berliner Weisse"){
            return "Sour"
        }  else if (style === "IPA - New England / Hazy"){
            return "Hazy IPA"
        }  else if (style === "Pale Ale - New England / Hazy"){
            return "Hazy Pale"
        } else if (style === "Pale Ale - English" || style === "Pale Ale - American"){
            return "Pale Ale"
        } else if (style.includes('Lager')){
            return "Lager"
        } else if (style.includes('Pilsner')){
            return "Pilsner"
        } else if (style.includes("Cider - Traditional")){
            return "Cider"
        } else if (style.includes("Stout - American")){
            return "Stout"
        } else if (style.includes("Stout - Russian Imperial")){
            return "Imperial Stout"
        } else if (style.includes("Brown Ale")){
            return "Brown Ale"
        } else if (style.includes("Wheat Beer - Witbier / Blanche")){
            return "Witbier"
        } else if (style.includes("Non-Alcoholic Beer")){
            return "NA Beer"
        }
        
            else {
            return style
        }
    }
   
    filterItem = (item) => {
        if (item.includes("Pilsner Style Beer")){
            return "Pilsner"
        } else if (item.includes("Bent Paddle Cold Press Nitro")){
            return "Cold Press Nitro"
        } else if (item.includes("Jameson Barrel Aged Brown Ale")){
            return "Jameson Barrel Aged"
        } else if (item.includes("Gravity Well")){
            return "Gravity Well"
        } else if (item.includes("Castle Cream Ale")){
            return "Cream Ale"
        } else if (item.includes("Lollygagger Pale Ale")){
            return "Lollygagger"
        } else if (item.includes("Pyro American Pale Ale")){
            return "Pyro American"
        } else if (item.includes("Bent Hop | India Pale Ale")){
            return "Bent Hop"
        } else if (item.includes("Cold Press Black | Coffee Ale")){
            return "Cold Press Black"
        } else if (item.includes("Venture Pils | Pilsener Lager")){
            return ("Venture Pils")
        }
        
        else {
            return item
        }
    }
    getCans = (menuId) => {
        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${menuId}`
        return fetch(url)
        .then(res => res.json())
        .then(data => {
            let cans = data.menu.sections[0].items
            this.setState({cansMenu: cans})
        })
        .catch(err => err)
    }

    getCocktails = (menuId) => {
        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${menuId}`
        return fetch(url)
        .then(res => res.json())
        .then(data => {
            console.log(data)
            let cocktails = data.menu.sections[0].items
            let mocktails = data.menu.sections[1].items
            this.setState({cocktailsMenu: cocktails, mocktailsMenus: mocktails})
        })
        .catch(err => err)
    }
    componentDidMount(){
        const cansId = this.props.match.params.cansId
        const cocktailsId = this.props.match.params.cocktailsId

        this.getCans(cansId)
        this.getCocktails(cocktailsId)
    }
    render(){
        console.log(this.state)
        return(
            <CansCocktailsTemplate 
                cansMenu={this.state.cansMenu}
                cocktailsMenu={this.state.cocktailsMenu}
                mocktailsMenu={this.state.mocktailsMenus}
                filterItem={this.filterItem}
                filterBrewery={this.filterBrewery}
                filterStyle={this.filterStyle}
                refactorAbv={this.refactorAbv}
                
            />
        )
    }
    
}
export default CansCocktails
